import "./globals";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./i18n";
import "./index.css";
import { Suspense } from "react";
import { StylesProvider } from "@material-ui/styles";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./configurations/themeProvider";

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <StylesProvider injectFirst>
      <BrowserRouter basename="/UI">
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </StylesProvider>
  </Suspense>,
  document.getElementById("root")
);
